import type { Topic } from './types';
import type { AnnouncementType } from '../../types';

export const TOPICS: { [type in Topic]: Topic } = {
  PATIENT_BROKEN_FOLLOWUP: 'PATIENT_BROKEN_FOLLOWUP',
  PATIENT_PRACTICE_BROKEN_FOLLOWUP: 'PATIENT_PRACTICE_BROKEN_FOLLOWUP',
  PATIENT_UNSCHEDULED_TX_FOLLOWUP: 'PATIENT_UNSCHEDULED_TX_FOLLOWUP',
  PATIENT_UNSCHEDULED_HYG_FOLLOWUP: 'PATIENT_UNSCHEDULED_HYG_FOLLOWUP',
};

export const ANNOUNCEMENT_TYPES: { [type in AnnouncementType]: AnnouncementType } = {
  COVID_19: 'COVID_19',
  GENERIC: 'GENERIC',
};

export const COUNTRY_CODES = {
  us: 'US',
};

export const PROVIDER_AVATAR =
  'https://assets.localmed.com/shared/images/avatars/provider-m-260.jpg';
export const MONTHS_ITEMS = [
  { id: '01', display: 'January' },
  { id: '02', display: 'February' },
  { id: '03', display: 'March' },
  { id: '04', display: 'April' },
  { id: '05', display: 'May' },
  { id: '06', display: 'June' },
  { id: '07', display: 'July' },
  { id: '08', display: 'August' },
  { id: '09', display: 'September' },
  { id: '10', display: 'October' },
  { id: '11', display: 'November' },
  { id: '12', display: 'December' },
];
